<template>
  <div class="container p-30px border-grey02 w-full">
    <div class="flex md:flex-row flex-col md:justify-between md:items-center mb-30px w-full">
      <div class="w-fit md:mb-0 mb-10px">
        <div class="flex items-center">
          <img
            :src="'/images/svg/projects/icon-list.svg'"
            class="md:h-30px h-24px mr-10px"
          />
          <h1 class="text-black01 font-medium md:text-lg text-sm">{{ title }}</h1>
        </div>
      </div>
      <div class=""></div>
      <div class="md:self-auto self-end">
        <div class="">
          <template v-if="search">
            <span class="search-result-count">
              <span class="search-result-count-number">{{
                projects.total
              }}</span>
              {{ "件見つかりました" }}
            </span>
          </template>
          <template v-else>
            <div class="flex">
              <a
                class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px mr-10px"
                v-bind:href="urls.create"
                >{{ "新規案件作成" }}</a
              >
              <button
                class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px"
                v-on:click="openSearchDialog"
              >
                {{ "案件検索" }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="container__content w-full overflow-x-auto">
      <div v-if="!search" class="tabs-wrapper project-tabs">
        <button
          v-for="(status_item, index) in statuses"
          v-bind:key="index"
          class="tab"
          v-bind:class="{ active: status_item.value == status }"
          v-on:click="selectStatus(status_item.value)"
        >
          <div class="name">{{ status_item.label }}</div>
        </button>
      </div>
      <table class="project-table md:whitespace-normal whitespace-nowrap">
        <thead>
          <tr>
            <th v-for="(header, index) in tableHeaders" v-bind:key="index">
              <template v-if="!header.sortable">
                {{ header.name }}
              </template>
              <template v-else>
                <a href="#" v-on:click="changeSort(header.key)">
                  {{ header.name }}
                </a>
                <i
                  class="fa"
                  v-bind:class="{
                    'fa-sort':
                      sortProperty != header.key ||
                      (sortDirection != 'asc' && sortDirection != 'desc'),
                    'fa-sort-up':
                      sortProperty == header.key && sortDirection == 'asc',
                    'fa-sort-down':
                      sortProperty == header.key && sortDirection == 'desc',
                  }"
                ></i>
              </template>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="project in projects.data" v-bind:key="project.id">
            <td class="w-1/10 min-w-100px">
              {{ formatISODate(project.created_at, "yyyy-MM-dd") }}<br />{{
                formatISODate(project.created_at, "HH:mm:ss")
              }}
            </td>
            <td class="w-1/10 min-w-100px">
              {{ projectStatusToName(project.status) }}
            </td>
            <td class="w-1/10 min-w-100px">
              <a
                class="opacity decoration"
                :href="buildProjectsShowUrl(project.id)"
                >{{ project.friendly_id }}</a>
            </td>
            <td class="w-3/10 min-w-150px">{{ project.customer ? project.customer.name : '' }}</td>
            <td class="w-3/10 min-w-150px">{{ project.name }}</td>
            <td class="w-1/10 min-w-100px">{{ project.manager ? project.manager.name : '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="container__footer">
      <div class="container__footer__block">
        <div>
          <div>
            <pagination
              :links="projects.links"
              :totalPages="projects.last_page"
            ></pagination>
          </div>
          <div v-if="search" class="footer-buttons">
            <a
              class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px lg:mr-10px lg:mb-0 mb-10px"
              v-bind:href="urls.projects.list"
              >{{ "一覧へ戻る" }}</a
            >
            <button
              class="block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px"
              v-on:click="openSearchDialog"
            >
              {{ "検索条件変更" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <search-dialog
      :dialog-data="searchDialog"
      v-on:close-dialog="closeSearchDialog"
      v-on:submit-search="submitSearch"
    ></search-dialog>
  </div>
</template>

<style scoped>
a {
  color: #323232;
}
</style>

<script>
import SearchDialog from "../SearchDialog.vue";
export default {
  components: { SearchDialog },
  props: {
    statuses: Array,
    projects: Object,
    pagination: Object,
    urls: Object,
    customersSearch: Array,
    usersSearch: Array,
  },
  data() {
    return {
      title: "案件一覧",
      status: 0,
      tableHeaders: [
        {
          sortable: true,
          key: "created_at",
          name: "作成日時",
        },
        {
          sortable: true,
          key: "status",
          name: "ステータス",
        },
        {
          sortable: true,
          key: "friendly_id",
          name: "案件ID",
        },
        {
          sortable: true,
          key: "customer.name",
          name: "クライアント",
        },
        {
          sortable: true,
          key: "name",
          name: "案件名",
        },
        {
          sortable: true,
          key: "manager.name",
          name: "作成者",
        },
      ],
      sortProperty: null,
      sortDirection: null,
      search: false,
      searchDialog: {
        shown: false,
        title: "案件検索",
        submitLabel: "検索",
        fields: [
          {
            property: "friendly_id",
            label: "ID",
            type: "text",
            value: "",
            default: "",
            class: "full-width",
          },
          {
            property: "user_id",
            label: "ユーザー",
            type: "select",
            value: null,
            default: null,
            options: this.usersSearch,
            class: "w-full",
            cast: "integer",
          },
          {
            property: "customer_id",
            label: "クライアント",
            type: "select",
            value: null,
            default: null,
            options: this.customersSearch,
            class: "w-full",
            cast: "integer",
          },
          {
            property: "name",
            label: "案件名",
            type: "text",
            value: "",
            default: "",
            class: "full-width",
          },
        ],
      },
    };
  },
  methods: {
    buildProjectsShowUrl: function (id) {
      return this.urls.show.replace(/__PROJECT_ID__/g, id);
    },
    projectStatusToName: function (status) {
      var result = this.statuses.find((status_item) => {
        return status_item.value === status;
      });
      if (result) {
        return result.label;
      }
      return "Unknown";
    },
    openSearchDialog: function () {
      this.searchDialog.shown = true;
    },
    closeSearchDialog: function () {
      this.searchDialog.shown = false;
    },
    submitSearch: function () {
      //this.closeSearchDialog();
      var params = new URLSearchParams(window.location.search);
      params.set("search", true);
      this.searchDialog.fields.forEach((field) => {
        params.delete(field.property);
        if (
          field.value != null &&
          !Number.isNaN(field.value) &&
          field.value != ""
        ) {
          params.set(field.property, field.value);
        }
      });
      window.location.search = params.toString();
    },
    selectStatus: function (status) {
      this.status = status;
      var params = new URLSearchParams(window.location.search);
      params.set("status", this.status);
      params.delete("page");
      window.location.search = params.toString();
    },
    changeSort: function (sort_key) {
      var sortDirection = this.sortDirection;
      if (this.sortProperty != sort_key) {
        sortDirection = "null";
      }
      this.sortProperty = sort_key;
      switch (sortDirection) {
        case "null":
          this.sortDirection = "asc";
          break;
        case "asc":
          this.sortDirection = "desc";
          break;
        case "desc":
          this.sortProperty = null;
          this.sortDirection = null;
          break;
      }
      var params = new URLSearchParams(window.location.search);
      params.delete("page");
      if (this.sortProperty !== null) {
        params.set("sort", this.sortProperty);
        params.set("direction", this.sortDirection);
      } else {
        params.delete("sort");
        params.delete("direction");
      }
      window.location.search = params.toString();
    },
  },
  mounted() {
    var params = new URLSearchParams(window.location.search);
    if (params.has("search")) {
      this.search = parseBoolean(params.get("search"));
    }
    if (params.has("status")) {
      this.status = params.get("status");
    }
    if (params.has("sort")) {
      this.sortProperty = params.get("sort");
    }
    if (params.has("direction")) {
      this.sortDirection = params.get("direction");
    }
    this.searchDialog.fields.forEach((field) => {
      if (field.cast == "integer") {
        field.value = parseInt(params.get(field.property));
      } else {
        field.value = params.get(field.property);
      }
    });
  },
};
</script>
